export default __webpack_public_path__ + "static/media/picto_Parsing_jaune_tech.c3c37ecf.svg";